var _polygon, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPythonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.231 7.357 18.232 7.357 18.232 7.353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BB30",
    d: "M20.699,17.748c1.666,0,2.282-1.162,2.861-2.904c0.6-1.794,0.574-3.52,0-5.818c-0.413-1.655-1.194-2.904-2.861-2.904h-2.147v2.541c0,1.971-1.672,3.632-3.578,3.632H9.252c-1.565,0-2.861,1.339-2.861,2.909v5.454c0,1.553,1.35,2.464,2.861,2.909c1.81,0.53,3.552,0.626,5.721,0c1.441-0.418,2.861-1.26,2.861-2.909v-2.181h-5.717v-0.728H20.699z M15.332,19.929c0.594,0,1.077,0.488,1.077,1.088c0,0.606-0.482,1.093-1.077,1.093c-0.59,0-1.077-0.493-1.077-1.093C14.261,20.411,14.744,19.929,15.332,19.929z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35668F",
    d: "M3.444,17.749H5.41v-2.615c0-1.891,1.634-3.558,3.578-3.558h5.721c1.591,0,2.861-1.312,2.861-2.909V3.209c0-1.553-1.307-2.717-2.861-2.978c-1.918-0.317-4.002-0.299-5.721,0.006l0.001-0.001C6.567,0.664,6.129,1.558,6.129,3.213v2.181h5.727v0.729H3.98c-1.666,0-3.124,1.002-3.578,2.904c-0.525,2.181-0.546,3.541,0,5.818C0.808,16.538,1.779,17.749,3.444,17.749z M8.63,3.937c-0.594,0-1.077-0.488-1.077-1.088C7.56,2.243,8.036,1.756,8.63,1.756c0.59,0,1.077,0.492,1.077,1.093S9.225,3.937,8.63,3.937z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonIcon);
export default __webpack_public_path__ + "static/media/python-icon.65a9d1c520efc51f9ae08222489d0f3a.svg";
export { ForwardRef as ReactComponent };